import { Device } from "src/models/device";
import { createEntityModel } from "src/store/models/entity/_shared";

export const DeviceEntityModel = createEntityModel<Device>();
